import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_SERVER}/Web/`;

const uploadEncryptS3 = async (imageData) => {
  try {
    const response = await axios.post(
      API_URL + "UploadFileEncryptBytesS3",
      imageData
      //   {
      //     headers: authHeader(),
      //   }
    );

    return response.data;
  } catch (error) {
    console.error("Error uploading image:", error);
    throw error;
  }
};

const DownloadEncryptImageAsByteArray = async (imageUrl, key) => {
  const imageData = {
    key: key,
    url: imageUrl,
  };

  try {
    const response = await axios.post(
      API_URL + "DownloadFileDecryptBytes",
      imageData
    );

    const decryptedBytes = response.data.result;
    // TODO: 처리할 작업 수행

    return decryptedBytes;
  } catch (error) {
    console.error("Error:", error);
  }

  async function DownloadEncryptImageAsByteArray(imageUrl) {
    const response = await fetch(imageUrl, { mode: "no-cors" });
    const buffer = await response.arrayBuffer();
    return new Uint8Array(buffer);
  }
};

const UploadFileService = {
  uploadEncryptS3,
  DownloadEncryptImageAsByteArray,
};

export default UploadFileService;
